/**
 * Shared Bed Board Client Permission Helpers.
 * R39 C10.b (plan docs/plans/sector-operations.md §Part C, SO-P254).
 */

import type { WorkspaceRole } from '../../../types/workspace'
import type { OpsPlace } from '../../../types/ops'

export interface BedBoardViewerContext {
  role?: WorkspaceRole | string | null
  sectorRoles?: readonly string[] | null
}

export function canManageBedBoard(
  viewer: BedBoardViewerContext,
  ward?: OpsPlace | null,
): boolean {
  const isOwnerOrAdmin = viewer.role === 'OWNER' || viewer.role === 'ADMIN'
  const isViewer = viewer.role === 'VIEWER'
  if (isOwnerOrAdmin) return true
  if (isViewer) return false
  if (!ward?.dutyChain) return false

  const dutyKeys = [
    ward.dutyChain.inChargeRoleKey,
    ward.dutyChain.backupRoleKey,
    ward.dutyChain.onCallRoleKey,
  ].filter(Boolean) as string[]

  return dutyKeys.some((k) => (viewer.sectorRoles ?? []).includes(k))
}

export function canOverrideBedReady(
  viewer: BedBoardViewerContext,
): boolean {
  return viewer.role === 'OWNER' || viewer.role === 'ADMIN'
}
